import { Component } from 'react';
import Raven from 'raven-js';
import { Flex } from 'foundations-components/components/Flex';
import { DynamicIcon } from 'foundations-assets/icons/DynamicIcon';
import { MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { Text } from 'foundations-components/components/Text';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { KeyIcon } from 'foundations-assets/icons/components/KeyIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isPermissionDisabled } from '../../../utils/dataPermissions/isPermissionDisabled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class IconErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, __errorInfo) {
    Raven.captureException(error, {
      extra: {
        iconName: this.props.name,
        permissionName: this.props.permission.name,
        message: 'AppPermission has an invalid icon name'
      }
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsx(KeyIcon, Object.assign({}, this.props));
    }
    return this.props.children;
  }
}
export function AppPermission(props) {
  const {
    permission,
    type
  } = props;
  const showConditionalInstallsAlert = isPermissionDisabled(type, permission);
  const iconName = permission.icon ? `${permission.icon.charAt(0).toUpperCase()}${permission.icon.slice(1)}` : 'Key';
  const iconProps = {
    name: iconName,
    size: '400'
  };
  return /*#__PURE__*/_jsx(MultiColumnGroup, {
    children: /*#__PURE__*/_jsx(MultiColumnItem, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "200",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "300",
          children: [/*#__PURE__*/_jsx(IconErrorBoundary, Object.assign({}, iconProps, {
            permission: permission,
            children: /*#__PURE__*/_jsx(DynamicIcon, Object.assign({}, iconProps))
          })), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-50",
              children: permission.longDescription
            }), /*#__PURE__*/_jsx(Text, {
              color: "text-core-subtle",
              typography: "detail-200",
              children: permission.name
            })]
          })]
        }), (type === `optional` || type === `conditionallyRequired`) && /*#__PURE__*/_jsx(Tooltip, {
          disabled: !showConditionalInstallsAlert,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app-governance-lib.dataPermissions.permissionsList.conditionallyRequiredOnExistingInstallTooltip"
          }),
          children: /*#__PURE__*/_jsx(Toggle, {
            size: "extra-small",
            checked: props.checked,
            disabled: showConditionalInstallsAlert,
            onChange: event => props.onChange(event.target.checked)
          })
        })]
      })
    })
  });
}